import React from "react";
import Reveal from "./Reveal";

/**
 * Standard inner-page header with overline + headline + optional description.
 * Lives directly under the navbar with a light background and accent bar.
 */
export default function PageHeader({ overline, title, description, accent }) {
  return (
    <section className="relative bg-[#F8FAFC] border-b border-slate-200 overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0 blueprint-grid opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-16 lg:py-24">
        <Reveal>
          {overline && (
            <div className="flex items-center gap-3 mb-5" data-testid="page-header-overline">
              <span className="h-px w-10 bg-[#123E73]" />
              <span className="text-xs tracking-[0.3em] font-semibold text-[#123E73]">{overline}</span>
            </div>
          )}
          <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-[64px] leading-[1.05] tracking-tight text-[#0A192F] max-w-4xl">
            {title}
            {accent && <span className="text-[#F5A400]">{accent}</span>}
          </h1>
          {description && (
            <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
